import React from 'react';
import Skeleton from '@mui/material/Skeleton';

const InteractionsListSkeletonRow = ({ showLabel }: { showLabel?: boolean }) => (
  <tr style={{ height: '3rem' }}>
    <td className="date">
      <Skeleton width="4rem" height="1.5rem" />
    </td>
    {showLabel ? (
      <td className="label">
        <Skeleton width="8rem" height="1.5rem" />
      </td>
    ) : null}
    <td className="status">
      <Skeleton width="5rem" height="1.5rem" />
    </td>
    <td className="receipt" />
  </tr>
);

export const InteractionsListSkeletonRows = ({
  rows = 5,
  showLabel = false,
}: {
  rows?: number;
  showLabel?: boolean;
}) => (
  <>
    {Array.from({ length: rows }).map((_, index) => (
      <InteractionsListSkeletonRow key={index} showLabel={showLabel} />
    ))}
  </>
);

export function InteractionsListSkeleton() {
  return (
    <section
      className="qlfeditor-interactions-list--skeleton qlf-skeleton"
      data-testid="interactions-list-skeleton"
      role="status"
      aria-live="polite"
      aria-label="Loading interactions"
    >
      <Skeleton height="2rem" width="100%" sx={{ marginBottom: '0.5rem' }} variant="rectangular" />
      <table className="qlf-table">
        <tbody>
          <InteractionsListSkeletonRows />
        </tbody>
      </table>
    </section>
  );
}
